import "./App-mobile-dock.css";
import { useEffect, useState } from "react";
import { NavLink, useLocation, useNavigate } from "react-router-dom";
// Same react-icons swap as AppSideBar.js / AppHeader.js, so the dock doesn't
// sit in Font Awesome solid glyphs while the rest of the chrome is outlined.
import { LuLayoutDashboard, LuShoppingCart, LuClipboardCheck } from "react-icons/lu";
import { FiShoppingBag, FiBell, FiUserPlus, FiPlus, FiLink } from "react-icons/fi";
import { HiOutlineClipboardList } from "react-icons/hi";
import { TfiWallet } from "react-icons/tfi";

// The dock's four destinations, split either side of the notch.
const LEFT_TABS = [
  { to: "/welcomeAdmin", Icon: LuLayoutDashboard, label: "Dashboard" },
  { to: "/customerOrders", Icon: FiShoppingBag, label: "Orders" },
];
const RIGHT_TABS = [
  { to: "/customerRequests", Icon: HiOutlineClipboardList, label: "Sourcing" },
  { to: "/notifications", Icon: FiBell, label: "Notifications" },
];

/**
 * Quick actions, surfaced on the FAB so they stay one tap away without occupying a
 * dock slot — the dock is fixed at two tabs either side of the notch, and all four of
 * those are load-bearing.
 *
 * The first four create something. "Sales Channels" does not, which is why the naming
 * here says quick actions rather than create actions — matching the FAB button's own
 * aria-label, which has always said "Quick actions".
 *
 * It is a SHORTCUT, not the only way in: AppSideBar renders inside a mobile drawer, so
 * the Sales Channels group has always been reachable there. What it buys is that an
 * admin checking a seller's failing store from a phone does not have to open the drawer
 * and expand an accordion to get to it. It points at Connected Stores because that is
 * the section's entry point and the group's first child in the sidebar.
 */
const FAB_ACTIONS = [
  { to: "/create-order", Icon: LuShoppingCart, label: "Create Order" },
  { to: "/create-sourcing-request", Icon: LuClipboardCheck, label: "Create Request" },
  { to: "/createNewCustomer", Icon: FiUserPlus, label: "Add End-Customer" },
  { to: "/customerWalletTopUp", Icon: TfiWallet, label: "Manual Adjustment" },
  // FiLink matches the icon AppSideBar.js gives this group, so the two agree.
  { to: "/integrations", Icon: FiLink, label: "Sales Channels" },
];

function AppMobileDock() {
  const [open, setOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  // A route change means the action was taken (or the user navigated away);
  // either way the submenu should not survive it.
  useEffect(() => { setOpen(false); }, [location.pathname]);

  const tab = ({ to, Icon, label }) => (
    <li key={to}>
      <NavLink to={to} className="mobile-icon-btn" aria-label={label} title={label}>
        <Icon />
      </NavLink>
    </li>
  );

  return (
    <>
      <div className={`fab-overlay ${open ? "open" : ""}`} onClick={() => setOpen(false)} />

      <div className="mobile-footer-container">
        <div className={`fab-submenu ${open ? "open" : ""}`}>
          {FAB_ACTIONS.map((action) => (
            <button
              key={action.to}
              type="button"
              className="fab-item"
              onClick={() => navigate(action.to)}
            >
              <span className="fab-item-icon"><action.Icon /></span>
              {action.label}
            </button>
          ))}
        </div>

        <div className="fab-wrapper">
          <button
            type="button"
            className={`fab-button ${open ? "open" : ""}`}
            onClick={() => setOpen((prev) => !prev)}
            aria-label={open ? "Close quick actions" : "Quick actions"}
            aria-expanded={open}
          >
            <FiPlus />
          </button>
        </div>

        <div className="mobile-footer-glass">
          <ul className="mobile-footer-nav">
            {LEFT_TABS.map(tab)}
            <li className="notch-spacer" aria-hidden="true"></li>
            {RIGHT_TABS.map(tab)}
          </ul>
        </div>
      </div>
    </>
  );
}

export default AppMobileDock;
